import { httpClient } from '@/shared/api/httpClient';
import { z } from 'zod';

/**
 * Aktywacja konta z linku (dec. 147).
 *
 * ⭐ Token jedzie w **ciele** żądania, nigdy w adresie: w adresie zostawałby w logach
 * żądań Kestrela i Caddy. Do przeglądarki trafia we **fragmencie** (`#`), którego
 * przeglądarka nie wysyła na serwer w ogóle.
 */

const checkSchema = z.object({ usable: z.boolean() });
const doneSchema = z.object({ login: z.string() });

export async function checkActivationToken(token: string, signal?: AbortSignal): Promise<boolean> {
  const response = await httpClient.post<unknown>(
    '/auth/activate/check',
    { token },
    // ⚠ `anonymous`: konto jeszcze nie ma hasła, więc odmowa NIE jest utratą sesji.
    //   Bez tego 401 z tej trasy wysyłałby użytkownika na logowanie w połowie aktywacji.
    { anonymous: true, ...(signal ? { signal } : {}) },
  );

  return checkSchema.parse(response).usable;
}

export async function activateAccount(token: string, password: string): Promise<string> {
  const response = await httpClient.post<unknown>(
    '/auth/activate',
    { token, password },
    { anonymous: true },
  );

  return doneSchema.parse(response).login;
}
